import { IChannelsController, callEnabledGetter, callLineGetter, callStarted, channelDisconnect, dataToDisconnectChannel, dataToGetCallEnabled, dataToGetLines, dataToGetTwilioToken, dataToGetWhatsAppActive, dataToHangUpCall, dataToSendCallTemplate, dataToStartCall, dataToUpdateWhatsAppBusinessProfile, dataToUpdateWhatsAppBusinessProfilePhoto, dataTogGetWhatsAppBusinessProfile, templateCallSend, whatsappBusinessProfile } from '../../domain/ChannelsController'
import ChannelsRepository from '../repository/Channels.repository'

export default class ChannelsController implements IChannelsController {
  repository: ChannelsRepository

  constructor () {
    this.repository = new ChannelsRepository()
  }

  abort (): void {
    this.repository.abortGetSuggestions()
  }

  async disconnectChannel (data: dataToDisconnectChannel) : Promise<channelDisconnect> {
    const response = await this.repository.disconnectChannel(data)
    return response
  }

  async getWhatsAppBusinessProfile (data: dataTogGetWhatsAppBusinessProfile) : Promise<whatsappBusinessProfile> {
    const response = await this.repository.getWhatsAppBusinessProfile(data)
    if (response.status) {
      return { status: true, data: response?.data[0] || {} }
    } else return { status: false, message: response?.message || '' }
  }

  async updateWhatsAppBusinessProfile (data: dataToUpdateWhatsAppBusinessProfile) : Promise<whatsappBusinessProfile> {
    const response = await this.repository.updateWhatsAppBusinessProfile(data)
    if (response.status) {
      return { status: true }
    } else return { status: false, message: response?.message || '' }
  }

  async updateWhatsAppBusinessProfilePhoto (data: dataToUpdateWhatsAppBusinessProfilePhoto) : Promise<whatsappBusinessProfile> {
    const response = await this.repository.updateWhatsAppBusinessProfilePhoto(data)
    if (response.status) {
      return { status: true }
    } else return { status: false, message: response?.message || '' }
  }

  async getCallWhatsAppEnabled (data: dataToGetCallEnabled): Promise<callEnabledGetter> {
    const response = await this.repository.getCallWhatsAppEnabled(data)
    if (response.status) return { status: true, data: response.data }
    else return { status: false, message: response.message }
  }

  async sendCallTemplate (data: dataToSendCallTemplate): Promise<templateCallSend> {
    const response = await this.repository.sendCallTemplate(data)
    return response
  }

  async startCall (data: dataToStartCall): Promise<callStarted> {
    const response = await this.repository.startCall(data)
    if (response.status) return { status: true, callId: response.data.callId || '' }
    else return { status: false, message: response.message }
  }

  async hangUpCall (data: dataToHangUpCall): Promise<{ message?: string, status: boolean }> {
    const response = await this.repository.hangUpCall(data)
    if (response.status) return { status: true }
    else return { status: false, message: response.message }
  }

  async getWhatsAppActive (data: dataToGetWhatsAppActive): Promise<{ status: boolean, message?: string }> {
    const response = await this.repository.getWhatsAppActive(data)
    if (response.data?.message) {
      if (response.data?.message?.includes('valid')) return { status: true }
      else return { status: false, message: response.data.message }
    }
    return { status: false, message: response?.data?.message }
  }

  async getTwilioToken (data: dataToGetTwilioToken): Promise<{ status: boolean, token?: string }> {
    const response = await this.repository.getTwilioToken(data)
    if (response.status) return { status: true, token: response.data.token || '' }
    else return { status: false }
  }

  async getAllCallLines (data: dataToGetLines): Promise<callLineGetter> {
    const response = await this.repository.getAllCallLines(data)
    if (response.status) {
      return { status: true, data: response.data.numbers || [] }
    } else {
      return { status: false, message: response.message }
    }
  }
}
